export default {
  designer: {
    Name: 'Name',
    DesignerIntroduce: 'Designer Introduce',
    PleaseEnterDesignerIntroduce: 'Please Enter Designer Introduce',
    DesignerNameCannotBeEmpty: 'Designer Name Cannot Be Empty',
    DoNotEnterSpecialSymbols: 'Do Not Enter Special Symbols',
    DesignerIntroduceCanNotBeEmpty: 'Designer Introduce Can NotBe Empty'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/pmc/designer.js